<script setup lang="ts">
import { withDefaults, defineProps, ref } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useFishTransfer } from "@/composables/tasks/animal-transfer/useAnimalTransfer";

interface Props {
    amount: number;
    showModal: boolean;
    toggleFishTransferLogModal: () => void
}

const props = withDefaults(defineProps<Props>(), {
    amount: 0,
    showModal: false
});

const comment = ref("");
const { addCommentOnTask } = useFishTransfer();

const handleInput = () => {
    addCommentOnTask(comment.value, props.amount);
};
</script>

<template>
    <ModalBox v-if="showModal" @close="toggleFishTransferLogModal">
        <template #header>Explain difference in planned and actual amount</template>
        <template #main>
            <textarea class="w-full h-28 rounded resize-none p-2 outline-secondary border border-gray-400 required"
                v-model="comment" @input="handleInput"></textarea>
        </template>
        <template #footer>
            <button @click="toggleFishTransferLogModal" type="button"
                class="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover: focus:z-10">
                Save
            </button>
            <button @click="toggleFishTransferLogModal" type="button"
                class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
                Close
            </button>
        </template>
    </ModalBox>
</template>
